import React from 'react'
import { Formik } from 'formik'
import { mergeSiteSchema } from '../../../lib/schemas'
import sitesOperations from '../../../store/sitesManager/operations'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import MergeSiteLayout from './MergeSiteLayout'

const MergeSiteContainer = props => {
  const { mergeSite } = props
  const enableValidation = formikProps =>
    formikProps.isSubmitting ||
    formikProps.isValidating ||
    !formikProps.isValid ||
    !formikProps.touched

  const enableSubmit = formikProps =>
    formikProps.mergeSiteState.mergeSiteResults && !formikProps.dirty

  const handleSubmit = async (values, { setSubmitting }) => {
    const { siteId, primarySiteId } = values
    await mergeSite({
      siteId,
      primarySiteId,
      isPreview: false,
    })
    setSubmitting(false)
  }

  const handleValidation = async (values, setSubmitting, resetForm) => {
    const { siteId, primarySiteId } = values
    setSubmitting(true)
    await mergeSite({
      siteId,
      primarySiteId,
      isPreview: true,
    })
    setSubmitting(false)
    resetForm(values)
  }

  const cleanForm = async resetForm => {
    resetForm({
      siteId: '',
      primarySiteId: '',
      hasValidatedMergeSite: false,
    })
  }

  return (
    <Formik
      initialValues={{
        siteId: '',
        primarySiteId: '',
        hasValidatedMergeSite: false,
      }}
      isInitialValid={false}
      onSubmit={handleSubmit}
      validationSchema={mergeSiteSchema}
    >
      {formikProps => {
        return (
          <form onSubmit={formikProps.handleSubmit}>
            <MergeSiteLayout
              {...props}
              {...formikProps}
              cleanForm={cleanForm}
              enableSubmit={enableSubmit}
              enableValidation={enableValidation}
              handleValidation={handleValidation}
            />
          </form>
        )
      }}
    </Formik>
  )
}

MergeSiteContainer.propTypes = {
  mergeSite: PropTypes.func.isRequired,
}

const mapStateToProps = ({ sitesManager }) => sitesManager

const mapDispatchToProps = {
  ...sitesOperations,
}

export default connect(mapStateToProps, mapDispatchToProps)(MergeSiteContainer)
